<template>
  <div class="data-autocomplete">
    <div data-app>
      <v-container fluid>
        <v-layout align-start justify-center row>
          <v-flex xs6>
            <v-autocomplete
                :attach="true"
                v-model="selectedData"
                :items="items"
                color="white"
                item-text="name"
                item-value="id"
                :multiple="false"
                :dense="true"
                :search-input.sync="search"
                :clearable="true"
                :hide-no-data="hideNoDataText"
                :hide-details="true"
                :hint="hint"
                :loading="loading"
                :filter="filterRecords"
                :return-object="true"
                prepend-inner-icon="fa-search"
                outline
                :placeholder="trans('app.search_in_dietico')"
            >
              <template v-slot:item="data">
                <template>
                  <v-list-tile-content>
                    <v-list-tile-title :title="data.item.name">
                      <span>{{ data.item.name }}</span>
                      <template v-if="data.item.shared">
                        <v-tooltip right>
                          <template #activator="{ on }">
                            <v-icon v-on="on" small color="success">share</v-icon>
                          </template>
                          <span>{{ trans('app.sharing.shared_by', {name: data.item.owned_by}) }}</span>
                        </v-tooltip>
                      </template>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import {trans} from "../app";

export default {
  data() {
    return {
      selectedData: null,
      entries: {food: [], menu_schemas: [], patients: [], products: []},
      userData: [],
      loading: false,
      search: null,
      hint: undefined,
      currentTimeout: null,
      hideNoDataText: true
    };
  },
  computed: {
    items() {
      if (this.entries.length === 0) {
        return [];
      }

      const {food, menu_schemas, patients, products} = this.entries;

      return [
        ...(patients.length ? [{header: trans('app.patients.patients')}] : []),
        ...(patients.map(patient => {
          return {...patient, group: 'patients'}
        })),
        ...(menu_schemas.length ? [{divider: true}, {header: trans('app.pages.schemas')}] : []),
        ...(menu_schemas.map(menuSchema => {
          return {...menuSchema, group: 'menu_schema'}
        })),
        ...(products.length ? [{divider: true}, {header: trans('app.pages.products.products')}] : []),
        ...(products.map(product => {
          return {...product, group: 'products'}
        })),
        ...(food.length ? [{divider: true}, {header: trans('app.pages.foods')}] : []),
        ...(food.map(meal => {
          return {...meal, group: 'food'}
        })),
      ];
    }
  },
  watch: {
    async search(val) {
      this.clearTimeoutIfExists();
      this.entries = [];
      this.hideNoDataText = true;

      if (!val) {
        this.hint = undefined;

        return;
      }

      this.hint = val.length > 0 && val.length < 3 ? trans('app.type_at_least_n_characters', {count: 3}) : undefined;

      if (val.length < 3) {
        return;
      }

      this.loading = true;
      this.currentTimeout = setTimeout(async () => {
        const {data} = await axios.get('/search', {params: {search: val}});
        this.entries = data.data;
        this.loading = false;
        this.currentTimeout = null;
        this.hideNoDataText = false;
      }, 500);
    },
    selectedData(selectedData) {
      if (!selectedData) {
        return;
      }

      let scope;
      switch (selectedData.group) {
        case 'food':
          if (selectedData.user_id === null) {
            scope = 'all';
          } else if(selectedData.shared) {
            scope = 'shared';
          } else {
            scope = 'own';
          }

          window.location = `/foods/${scope}/${selectedData.id}`;
          break;
        case 'menu_schema':
          window.location = `/schemas/${selectedData.id}`;
          break;
        case 'patients':
          window.location = `/patients/${selectedData.id}/panel`;
          break;
        case 'products':
          if (selectedData.user_id === null) {
            scope = 'all';
          } else if(selectedData.shared) {
            scope = 'shared';
         } else {
            scope = 'own';
          }

          window.location = `/products/${scope}/?id=${selectedData.id}`;
          break;
      }
    }
  },
  methods: {
    clearTimeoutIfExists() {
      if (this.currentTimeout !== null) {
        clearTimeout(this.currentTimeout);
        this.currentTimeout = null;
        this.loading = false;
      }
    },
    filterRecords(item, queryText, itemText) {
      return true;
    }
  }
}
</script>
